import React from 'react';
import type { OpenSidePanelsParams } from '@alfa-bank/newclick-types/open-side-panel-params';
import loadable, { LoadableComponent } from '@loadable/component';

import { SidePanelId } from './constans/side-panel-id';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SidePanelProps<T = any> = {
    sidePanelParams: T;
    openPreviousSidePanel?: VoidFunction;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sidePanelMapper: Record<string, LoadableComponent<any>> = {
    [SidePanelId.Inform]: loadable(() => import('./components/modal-inform')),
    [SidePanelId.Connections]: loadable(() => import('./components/modal-connections')),
    [SidePanelId.Chat]: loadable(() => import('./components/modal-chat')),
    [SidePanelId.AltLogin]: loadable(() => import('./components/modal-alt-login')),
};

export const Panels = ({
    sidePanelParams,
    openPreviousSidePanel,
}: SidePanelProps<OpenSidePanelsParams>) => {
    if (!sidePanelParams.sidePanelId) {
        return null;
    }

    const handleUnknownSidePanelId = (id: string) => {
        // eslint-disable-next-line no-console
        console.error(`[SIDE PANEL MANAGER] Side panel id=${id} is not found`);
    };

    const SidePanelComponent = sidePanelMapper[sidePanelParams.sidePanelId];

    if (SidePanelComponent) {
        return (
            <SidePanelComponent
                sidePanelParams={sidePanelParams}
                openPreviousSidePanel={openPreviousSidePanel}
            />
        );
    }

    switch (sidePanelParams.sidePanelId) {
        default:
            handleUnknownSidePanelId(sidePanelParams.sidePanelId);

            return null;
    }
};
